export const en = {
    "k_ff4b4ab7": "Data source middleware cannot be registered twice"
};
